import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createSlots as _createSlots, unref as _unref } from "vue";
const _hoisted_1 = { class: "criteria-item" };
const _hoisted_2 = { class: "d-flex align-center gap-2 mb-1" };
const _hoisted_3 = {
    key: 2,
    class: "page-chips-container"
};
const _hoisted_4 = {
    key: 0,
    class: "ml-8 mt-2 space-y-1"
};
import { computed, inject } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PolicyReviewCriteriaItem',
    props: {
        criterion: {},
        currentPageId: { default: null },
        pageManager: { default: null },
        status: { default: null },
        attachedPages: { default: () => [] }
    },
    emits: ["status-change", "page-action"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // Inject helper functions from parent
        const getCriterionStatus = inject("getCriterionStatus", (criterion) => criterion.status || "pending");
        const getPageAttachments = inject("getPageAttachments", () => []);
        const hasChildren = computed(() => {
            return props.criterion.children && props.criterion.children.length > 0;
        });
        const currentStatus = computed(() => {
            return props.status || props.criterion.status || "pending";
        });
        const statusIcon = computed(() => {
            if (currentStatus.value === "pass")
                return "mdi-check-circle";
            if (currentStatus.value === "fail")
                return "mdi-close-circle";
            return "mdi-alert-circle";
        });
        const statusColor = computed(() => {
            if (currentStatus.value === "pass")
                return "success";
            if (currentStatus.value === "fail")
                return "error";
            return "warning";
        });
        const statusOptions = [
            { value: "pass", label: "Present" },
            { value: "fail", label: "Missing" },
            { value: "pending", label: "Pending" },
        ];
        const getStatusIcon = (status) => {
            if (status === "pass")
                return "mdi-check-circle";
            if (status === "fail")
                return "mdi-close-circle";
            return "mdi-alert-circle";
        };
        const getStatusColor = (status) => {
            if (status === "pass")
                return "success";
            if (status === "fail")
                return "error";
            return "warning";
        };
        // Combine detected pages (from pageRef/pageNumbers) with manually attached pages
        const allPageChips = computed(() => {
            const chips = [];
            // Add detected pages (from policy review)
            if (props.criterion.pageNumbers && props.criterion.pageNumbers.length > 0) {
                props.criterion.pageNumbers.forEach((pageNum) => {
                    const pageId = props.pageManager?.pages[pageNum]?.id;
                    if (pageId) {
                        chips.push({
                            id: pageId,
                            displayNumber: pageNum + 1,
                            isManual: false, // Detected pages are not manually added
                        });
                    }
                });
            }
            else if (props.criterion.pageRef !== undefined) {
                const pageId = props.pageManager?.pages[props.criterion.pageRef]?.id;
                if (pageId) {
                    chips.push({
                        id: pageId,
                        displayNumber: props.criterion.pageRef + 1,
                        isManual: false,
                    });
                }
            }
            // Add manually attached pages
            if (props.attachedPages && props.attachedPages.length > 0) {
                props.attachedPages.forEach((pageId) => {
                    // Only add if not already in chips (avoid duplicates)
                    if (!chips.find((c) => c.id === pageId)) {
                        chips.push({
                            id: pageId,
                            displayNumber: (props.pageManager?.getPageNumber(pageId) ?? 0) + 1,
                            isManual: true, // Manually added pages can be removed
                        });
                    }
                });
            }
            return chips;
        });
        const onStatusSelect = (newStatus) => {
            emit("status-change", props.criterion.id, newStatus);
        };
        const onAddPage = () => {
            if (props.currentPageId) {
                emit("page-action", props.criterion.id, "add", props.currentPageId);
            }
        };
        const onRemovePage = (pageId) => {
            emit("page-action", props.criterion.id, "remove", pageId);
        };
        // Event handlers for child component events
        const handleStatusChange = (criterionId, newStatus) => {
            emit("status-change", criterionId, newStatus);
        };
        const handlePageAction = (criterionId, action, pageId) => {
            emit("page-action", criterionId, action, pageId);
        };
        // Navigate to page when chip is clicked
        const onChipClick = (pageChip) => {
            if (!props.pageManager)
                return;
            const pageIndex = props.pageManager.getPageNumber(pageChip.id);
            if (pageIndex !== -1) {
                props.pageManager.goToPage(pageIndex);
            }
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_PolicyReviewCriteriaItem = _resolveComponent("PolicyReviewCriteriaItem", true);
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (!hasChildren.value)
                        ? (_openBlock(), _createBlock(_component_v_menu, {
                            key: 0,
                            location: "bottom start"
                        }, {
                            activator: _withCtx(({ props: menuProps }) => [
                                _createVNode(_component_v_btn, _mergeProps(menuProps, {
                                    size: "small",
                                    variant: "text",
                                    color: statusColor.value,
                                    class: "status-selector",
                                    icon: ""
                                }), {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                            icon: statusIcon.value,
                                            size: "small"
                                        }, null, 8, ["icon"])
                                    ]),
                                    _: 2
                                }, 1040, ["color"])
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_v_list, null, {
                                    default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (statusOption) => {
                                            return _createVNode(_component_v_list_item, {
                                                key: statusOption.value,
                                                onClick: ($event) => (onStatusSelect(statusOption.value))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, { class: "d-flex align-center gap-2" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                                icon: getStatusIcon(statusOption.value),
                                                                color: getStatusColor(statusOption.value),
                                                                size: "small"
                                                            }, null, 8, ["icon", "color"]),
                                                            _createTextVNode(" " + _toDisplayString(statusOption.label), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1032, ["onClick"]);
                                        }), 64))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }))
                        : (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            icon: statusIcon.value,
                            color: statusColor.value,
                            size: "small",
                            class: "status-icon"
                        }, null, 8, ["icon", "color"])),
                    _createElementVNode("span", {
                        class: _normalizeClass(["text-body-2 flex-grow-1", { 'font-weight-medium': hasChildren.value }])
                    }, _toDisplayString(_ctx.criterion.text), 3),
                    (allPageChips.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allPageChips.value, (pageChip) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: pageChip.id,
                                    size: "x-small",
                                    density: "compact",
                                    color: "blue-gray",
                                    class: "cursor-pointer page-chip",
                                    onClick: ($event) => (onChipClick(pageChip)),
                                    "onClick:close": ($event) => (onRemovePage(pageChip.id))
                                }, _createSlots({
                                    default: _withCtx(() => [
                                        _createTextVNode(" Page " + _toDisplayString(pageChip.displayNumber), 1)
                                    ]),
                                    _: 2
                                }, [
                                    (pageChip.isManual)
                                        ? {
                                            name: "close",
                                            fn: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                    icon: "mdi-close",
                                                    size: "12"
                                                })
                                            ]),
                                            key: "0"
                                        }
                                        : undefined
                                ]), 1032, ["onClick", "onClick:close"]));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.currentPageId)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 3,
                            size: "x-small",
                            color: "primary",
                            variant: "text",
                            onClick: onAddPage
                        }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode("Assign Page", -1)
                            ])),
                            _: 1,
                            __: [0]
                        }))
                        : _createCommentVNode("", true)
                ]),
                (hasChildren.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.criterion.children, (child) => {
                            return (_openBlock(), _createBlock(_component_PolicyReviewCriteriaItem, {
                                key: child.id,
                                criterion: child,
                                "current-page-id": _ctx.currentPageId,
                                "page-manager": _ctx.pageManager,
                                status: _unref(getCriterionStatus)(child),
                                "attached-pages": _unref(getPageAttachments)(child.id),
                                onStatusChange: handleStatusChange,
                                onPageAction: handlePageAction
                            }, null, 8, ["criterion", "current-page-id", "page-manager", "status", "attached-pages"]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
